import FileMultiUpload from './FileMultiUpload'

export default FileMultiUpload
